import React, { useEffect, useRef } from 'react';
import './Hero.css';

export default function Hero() {
  const gridRef = useRef(null);

  useEffect(() => {
    const grid = gridRef.current;
    if (!grid) return;
    const cells = [];
    const cols = 20;
    const rows = 12;
    for (let i = 0; i < cols * rows; i++) {
      const cell = document.createElement('div');
      cell.className = 'hero__grid-cell';
      grid.appendChild(cell);
      cells.push(cell);
    }
    const flicker = () => {
      const idx = Math.floor(Math.random() * cells.length);
      cells[idx].classList.add('lit');
      setTimeout(() => cells[idx].classList.remove('lit'), 600 + Math.random() * 800);
    };
    const interval = setInterval(flicker, 120);
    return () => { clearInterval(interval); cells.forEach(c => c.remove()); };
  }, []);

  return (
    <section className="hero">
      <div className="hero__grid" ref={gridRef} />
      <div className="hero__glow" />

      <div className="hero__content container">
        <div className="hero__tag">
          <span className="hero__tag-dot" />
          <span>Новосибирск · AI-стартап · Ранняя стадия</span>
        </div>

        <h1 className="hero__title">
          <span className="hero__title-line">AI для</span>
          <span className="hero__title-line hero__title-accent">
            людей,<span className="hero__cursor">_</span>
          </span>
          <span className="hero__title-line">не корпораций</span>
        </h1>

        <p className="hero__sub">
          Строим агентские ИИ-системы, которыми пользуется каждый —
          не только те, у кого есть большой бюджет.
        </p>

        <div className="hero__actions">
          <a href="#join" className="hero__btn hero__btn--primary">
            Стать частью команды
          </a>
          <a href="#about" className="hero__btn hero__btn--ghost">
            Узнать больше →
          </a>
        </div>

        <div className="hero__logo-wrap">
          <div className="hero__logo-ring" />
          <div className="hero__logo-ring hero__logo-ring--2" />
          <img src="/logo.png" alt="UrajiTech logo" className="hero__logo" />
        </div>
      </div>

      <div className="hero__scroll">
        <div className="hero__scroll-line" />
        <span>scroll</span>
      </div>
    </section>
  );
}
